import React from "react";
import { Card, CardBody, CardText, CardTitle, Button } from "reactstrap";
import { Link } from "react-router-dom";
import "../workout.css";
import "../card.css";
import WorkoutApi from "../Api";

const WorkoutCard = ({ id, name, description }) => {
  let newUser = JSON.parse(localStorage.getItem("user"));
  console.log(id);

  const deleteWorkouts = () => {
    WorkoutApi.deleteWorkout(newUser.id, id).then((res) => console.log(res));
  };

  return (
    <>
      <Card className="my-2 flex-group">
        <CardBody>
          <CardTitle tag="h5">
            <a className="bebas-neue" href={`/workouts/${id}`}>
              <h1>Workout : {name}</h1>
            </a>
          </CardTitle>
          <CardText>
            <small className="text-muted">Description: {description}</small>
          </CardText>

          <Link to={`/workouts/${id}/edit`}>
            <Button className="buttonspace">Edit Workout</Button>
          </Link>

          <a href="/workouts">
            <Button
              className="buttonspace"
              color="primary"
              onClick={deleteWorkouts}
            >
              Delete Workout
            </Button>
          </a>
        </CardBody>
      </Card>
    </>
  );
};

export default WorkoutCard;
